var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative t3m-ImageMap isolate"},[(_vm.backgroundUrl)?_c('t3m-video'):_vm._e(),(_vm.hotspots.length)?_c('t3m-hotspots',{on:{"seek":_vm.seek}}):_vm._e(),(_vm.status === 'wait')?_c('t3m-modal'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }